export const congregationsEn = {
  congregations: {
    list: {
      title: 'CHWZ Congregations',
      description: 'List of congregations of the Christian Pentecostal Community',
      unpublish: 'Unpublish',
      unpublishConfirm: 'Are you sure you want to unpublish this congregation?',
      unpublishSuccess: 'Congregation has been unpublished',
      unpublishError: 'Failed to unpublish congregation',
      create: 'Add congregation',
      createTitle: 'Add new congregation',
      createDescription: 'Create a new congregation. You can fill in the full details (address, service times) afterwards.',
      createSuccess: 'Congregation has been created',
      createDraftHint: 'The congregation is visible as a draft. To publish it publicly, add an address and set the address status to published.',
      createError: 'Failed to create congregation',
      nameRequired: 'Name is required',
      deleteConfirm: 'Are you sure you want to delete this congregation?',
      deleteSuccess: 'Congregation has been deleted',
      deleteError: 'Failed to delete congregation',
      error: 'Failed to load congregations list',
      empty: 'No congregations to display',
      searchPlaceholder: 'Search congregations...',
      noResults: 'No results for your search',
      branch: 'Branch',
      branchOf: 'Branch of {name}',
      view: {
        grid: 'Grid',
        list: 'List',
        map: 'Map',
        toggleLabel: 'Display mode',
        mapMissingCoordinates: 'No congregations without coordinates | 1 congregation without coordinates is not shown | {count} congregations without coordinates are not shown',
      },
    },
    detail: {
      title: 'Congregation',
      notFound: 'This congregation was not found or you do not have access to it.',
      notFoundTitle: 'Congregation not found',
      errorTitle: 'Something went wrong',
      error: 'Failed to load congregation data',
      edit: 'Edit',
      address: 'Address',
      congregationContact: 'Congregation contact',
      serviceTimes: 'Service Times',
      contacts: 'Contact',
      hiddenContacts: 'Hidden (visible to editors only)',
      branches: 'Branches',
      back: 'Back to congregations list',
      map: 'Map',
      openInGoogleMaps: 'Open in Google Maps',
    },
    map: {
      unavailable: 'Map is temporarily unavailable',
    },
    share: {
      title: 'Share by link',
      globalTitle: 'Share all congregations',
      globalDescription: 'Anyone with this link can browse every published congregation without an account. The access level below controls how much contact detail is revealed.',
      readOnlyNote: 'The link only ever grants read-only viewing at the chosen level — never editing rights or membership.',
      create: 'Create link',
      createTitle: 'Create a share link',
      createError: 'Failed to create link',
      empty: 'No active links',
      visibilityLevel: 'Visibility level',
      expiresIn: 'Expires in',
      expiresInDays: '{count} days',
      expiresAt: 'Expires: {date}',
      label: 'Label (optional)',
      labelPlaceholder: 'e.g. For John Smith',
      generatedLink: 'Generated link',
      copyLink: 'Copy link',
      copySuccess: 'Link copied to clipboard',
      revoke: 'Revoke',
      revokeConfirm: 'Are you sure you want to revoke this link? It will stop working immediately.',
      revokeSuccess: 'Link has been revoked',
      revokeError: 'Failed to revoke link',
    },
    sharedView: {
      title: 'Shared congregation',
      allTitle: 'Congregations',
      invalidTitle: 'Invalid link',
      invalid: 'This link is invalid, expired, or has been revoked.',
      poweredBy: 'Shared via',
    },
    filters: {
      searchPlaceholder: 'Search by name, city, address, contact...',
      country: 'Country',
      anyCountry: 'All countries',
      province: 'Province',
      anyProvince: 'All provinces',
      hideBranches: 'Hide branches',
      reset: 'Clear filters',
      more: 'More',
      less: 'Less',
      resultCount: 'No congregations | 1 congregation | {count} congregations',
      myLocation: 'Use my location',
      locating: 'Locating...',
      locationError: 'Failed to determine your location',
      clearLocation: 'Clear location',
      maxDistance: 'Radius',
      anyDistance: 'Any',
      distanceKm: '{km} km',
      sortByDistance: 'Sort by distance',
      missingCoordinates: 'No congregations skipped | 1 congregation skipped (no coordinates) | {count} congregations skipped (no coordinates)',
    },
    export: {
      button: 'Export',
      json: 'Export to JSON',
      markdown: 'Export to Markdown',
      title: 'CHWZ Congregations',
      exportedAt: 'Exported',
      count: 'Items',
      branchOf: 'Branch of congregation',
      address: 'Address',
      serviceTimes: 'Services',
      contact: 'Contact',
      previewTitle: 'Markdown export preview',
      previewDescription: 'Copy the content or download a .md file',
      download: 'Download',
      copyError: 'Failed to copy to clipboard',
    },
    status: {
      unverified: 'Unverified',
      draft: 'Draft',
      published: 'Published',
      publishedUnverified: 'Published (Unverified)',
      needVerification: 'Requires verification',
    },
    edit: {
      title: 'Edit Congregation',
      subtitle: 'Manage congregation information',
      loadError: 'Failed to load congregation data',
      nameRequired: 'Name is required',
      lastUpdatedBy: 'Last updated',
      basicInfo: {
        title: 'Basic Information',
        name: 'Name',
        namePlaceholder: 'Enter congregation name',
        description: 'Description',
        descriptionPlaceholder: 'Enter congregation description (optional)',
        status: 'Status',
        saveSuccess: 'Basic information has been saved',
        saveError: 'Failed to save basic information',
      },
      address: {
        title: 'Address',
        street: 'Street',
        streetPlaceholder: 'Enter street',
        city: 'City',
        cityPlaceholder: 'Enter city',
        cityRequired: 'City is required',
        postalCode: 'Postal Code',
        postalCodePlaceholder: 'Enter postal code',
        province: 'Province',
        provincePlaceholder: 'Enter province',
        country: 'Country',
        website: 'Website',
        websitePlaceholder: 'e.g. https://example.com',
        email: 'Congregation e-mail',
        emailPlaceholder: 'e.g. contact\\@example.com',
        emailInvalid: 'Invalid e-mail address',
        iban: 'Account number',
        ibanPlaceholder: 'e.g. 61 1090 1014 0000 0712 1981 2874',
        location: 'Map location',
        latitude: 'Latitude',
        longitude: 'Longitude',
        mapClickHint: 'Click on the map to set the congregation location',
        mapDragHint: 'Drag the pin to fine-tune the location',
        geocodeButton: 'Geocode address',
        geocoding: 'Geocoding...',
        geocodeSuccess: 'Coordinates have been filled in',
        geocodeNotFound: 'No coordinates found for this address',
        geocodeError: 'Failed to geocode address',
        status: 'Address Status',
        saveSuccess: 'Address has been saved',
        saveError: 'Failed to save address',
      },
      serviceTimes: {
        title: 'Service Times',
        empty: 'No service times. Click "Add" to add a new one.',
        saveSuccess: 'Service times have been saved',
        saveError: 'Failed to save service times',
      },
      serviceTime: {
        day: 'Day',
        dayPlaceholder: 'e.g. Sunday',
        dayRequired: 'Day is required',
        time: 'Time',
        timePlaceholder: 'e.g. 10:00',
        timeRequired: 'Time is required',
        description: 'Description',
        descriptionPlaceholder: 'e.g. Night prayer',
      },
      weekdays: {
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
      },
      weekdaysShort: {
        sunday: 'Sun',
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
      },
      serviceTimeQuickAdd: {
        title: 'Quick add',
        hint: 'Select days, enter a time, and add several entries at once.',
        time: 'Time',
        add: 'Add selected days',
      },
      contactPersons: {
        title: 'Contact Persons',
        empty: 'No contact persons. Click "Add" to add a new one.',
        saveSuccess: 'Contact persons have been saved',
        saveError: 'Failed to save contact persons',
      },
      contactPerson: {
        name: 'Full Name',
        namePlaceholder: 'Enter full name',
        nameRequired: 'Full name is required',
        title: 'Title/Position',
        titlePlaceholder: 'e.g. Pastor',
        email: 'Email',
        emailPlaceholder: 'Your email address',
        phone: 'Phone',
        phonePlaceholder: '+48 123 456 789',
      },
    },
    branches: {
      title: 'Branches',
      empty: 'No branches',
      name: 'Branch name',
      namePlaceholder: 'e.g. Praga Branch',
      add: 'Add',
      added: 'Branch added',
      removed: 'Branch removed',
      removeConfirm: 'Are you sure you want to remove this branch?',
    },
    people: {
      title: 'People and services',
      empty: 'No assignments',
      added: 'Person added',
      updated: 'Changes saved',
      editTitle: 'Edit person',
      removed: 'Assignment removed',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      customService: 'Other service',
      customServiceName: 'Service name',
      service: 'Service',
      servicePlaceholder: 'Select service',
      description: 'Description',
      createAccount: 'Create user account',
      pastorInactive: 'pastor: inactive account',
      add: 'Add person',
      addFormTitle: 'Add new person',
      profileVisibilityTitle: 'Profile visibility',
      showOnList: 'Show on congregation list',
      showOnListHint: 'Checked people appear on the short card in the congregation search. List order matches the order on the list.',
      moveUp: 'Move up',
      moveDown: 'Move down',
      removeConfirm: 'Are you sure you want to remove this person from the congregation?',
      visibility: {
        hidden: 'Hidden',
        public: 'Public',
        authenticated: 'Authenticated users',
        pastors: 'Pastors and bishops',
      },
      accountRole: 'Permissions',
      accountRolePlaceholder: 'Select permissions',
      roles: {
        none: 'None (basic)',
        member: 'Member',
        owner: 'Owner',
        pastor: 'Pastor',
        diacon: 'Deacon',
        bishop: 'Bishop',
        regional_bishop: 'Regional bishop',
        branch_responsible: 'Branch responsible',
      },
      noServiceTypes: 'No service types in database. Run: python -m cli db churches-backfill',
      accountStatus: {
        none: 'No account',
        invited: 'Invited',
        expired: 'Invite expired',
        active: 'Active',
      },
      sendInvite: 'Send invitation',
      resendInvite: 'Resend invitation',
      inviteSent: 'Invitation sent',
    },
    changeHistory: {
      title: 'Change history',
      empty: 'No changes recorded',
      loadError: 'Failed to load change history',
      source: {
        admin_manual: 'Manual edit',
        import_paste: 'Text import',
        email_auto: 'E-mail (automatic)',
        email_reviewed: 'E-mail (manually approved)',
      },
    },
    completeness: {
      title: 'Profile completeness',
      missingPrefix: 'Missing:',
      filterLabel: 'Completeness',
      filterAll: 'All',
      filterLow: 'Low (below 40%)',
      filterMedium: 'Medium (40–74%)',
      filterHigh: 'High (75% and up)',
      fields: {
        description: 'Description',
        street: 'Street',
        postal_code: 'Postal code',
        province: 'Province',
        website: 'Website',
        geolocation: 'Map location',
        service_times: 'Service times',
        card_contacts: 'Contact persons',
        contact_email: 'Contact with an email',
        contact_phone: 'Contact with a phone',
      },
    },
  },
}
